module.exports = __webpack_public_path__ + "img/scroll-down-arrow.d964cab9.svg";